import { useContext } from 'react';
import { ModulAvisContext } from '../../context/ModulAvisProvider';

export const useModulAvis = () => {
    const { isModulAvisActive, setModulAvisActive } = useContext(ModulAvisContext);

    return {
        isModulAvisActive,
        setModulAvisActive
    };
};
